import React, { useRef } from 'react';

import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { ModalBody } from '@qality/common-components';
import {
  QAlityIssueViewContextInitProps,
  QAlityIssueViewInitProps,
  TestCaseFullScreenCloseCallbackData,
} from '@qality/common-model/src/TestCaseFullScreenData';
import { TestStepsIssueView } from '@qality/common-pages';
import { QAlityIssueViewContextProvider } from '@qality/common-state';

type Props = {
  qalityIssueViewContextInitProps: QAlityIssueViewContextInitProps;
  qalityIssueViewInitProps: QAlityIssueViewInitProps;
  onClose: (data: TestCaseFullScreenCloseCallbackData) => void;
};

export default function TestCaseFullScreenDialog({
  qalityIssueViewContextInitProps,
  qalityIssueViewInitProps,
  onClose,
}: Props): JSX.Element {
  const testStepsIssueViewRef = useRef(null);

  const onCloseModal = () => {
    const { state } = testStepsIssueViewRef.current;
    if (state) {
      const { testCase } = state;
      onClose({ testCase });
      return;
    }

    onClose(null);
  };

  return (
    <ModalTransition>
      <Modal
        onClose={onCloseModal}
        shouldCloseOnOverlayClick
        shouldCloseOnEscapePress
        shouldScrollInViewport
        autoFocus
        width='90%'
      >
        <ModalBody>
          <div id='com_soldevelo_apps_test-management_container'>
            <QAlityIssueViewContextProvider
              initProps={qalityIssueViewContextInitProps}
            >
              <TestStepsIssueView
                initProps={qalityIssueViewInitProps}
                ref={testStepsIssueViewRef}
                dialogProps={{ isInDialog: true, onDialogClose: onCloseModal }}
              />
            </QAlityIssueViewContextProvider>
          </div>
        </ModalBody>
      </Modal>
    </ModalTransition>
  );
}
